import { useContext } from 'react';
import { useInterpret } from '@xstate/react';
import { DataAccessContext } from '@chargify/data-access';
import { useServices } from './useServices';
import { addOnsConfiguration } from '../machines';
import { UpdateAllocationsListDoneEvent } from '../machines/addOnsConfiguration/types';

export const useAddonsConfigurationService = (catalogId: number) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { subscriptionsService } = useServices();

  return useInterpret(addOnsConfiguration, {
    services: {
      getComponents: (context) =>
        dataAccess.getComponents(context.subscriptionId),
      previewComponentAllocations: (context) => {
        return dataAccess.previewComponentAllocations(context.subscriptionId, {
          allocations: context.allocations.map((a) => ({
            ...a,
            quantity: +a.quantity,
          })),
        });
      },
      updateComponentAllocations: (context) => {
        return dataAccess.updateComponentAllocations(context.subscriptionId, {
          allocations: context.allocations.map((a) => ({
            ...a,
            quantity: +a.quantity,
          })),
        });
      },
    },
    actions: {
      updateSubscriptionBalance: (
        context,
        event: UpdateAllocationsListDoneEvent
      ) => {
        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          subscriptionId: Number(context.subscriptionId),
          currentBillingAmountInCents:
            event.data.subscription.currentBillingAmountInCents,
          balanceInCents: event.data.subscription.balanceInCents,
          catalogId,
        });
      },
    },
  });
};

export type AddonsConfigurationService = ReturnType<
  typeof useAddonsConfigurationService
>;
